import { useEffect, useRef } from 'react'

import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

interface MapProps {
  latitude: string | number
  longitude: string | number
  zoom?: number
  iconUrl?: string
  iconWidth?: number
  iconHeight?: number
  popupContent?: string
  className?: string
  style?: React.CSSProperties
}

export const LeafletStaticMap = ({
  latitude,
  longitude,
  zoom = 18,
  iconUrl = '/images/markerPlaenge.png',
  iconWidth = 32,
  iconHeight = 43,
  popupContent,
  className = 'rounded border',
  style = { minHeight: '400px' },
}: MapProps) => {
  const mapRef = useRef<HTMLDivElement>(null)
  const mapInstanceRef = useRef<L.Map | null>(null)

  useEffect(() => {
    if (!mapRef.current || !latitude || !longitude) return

    const lat = Number(latitude)
    const lng = Number(longitude)

    const map = L.map(mapRef.current, {
      center: [lat, lng],
      zoom,
      attributionControl: false,
      zoomControl: false,
      scrollWheelZoom: false,
    })

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map)

    const customIcon = L.icon({
      iconUrl,
      iconSize: [iconWidth, iconHeight],
      iconAnchor: [iconWidth / 2, iconHeight],
      popupAnchor: [0, -iconHeight],
    })

    const marker = L.marker([lat, lng], { icon: customIcon }).addTo(map)
    if (popupContent) {
      marker.bindPopup(popupContent)
    }

    mapInstanceRef.current = map
    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove()
        mapInstanceRef.current = null
      }
    }
  }, [latitude, longitude, zoom, iconUrl, iconWidth, iconHeight, popupContent])

  return <div ref={mapRef} className={className} style={style} />
}
